import React, { Fragment } from "react";


const NotFound = () => {

    return (
        <Fragment>
            <h2>Page Not Found</h2>
        </Fragment>
    );
};

export default NotFound;
